<template>
  <router-link
    class="weather-control"
    :class="{ disabled }"
    :aria-current="isWeatherOpen ? 'page' : 'false'"
    aria-label="Weather"
    :inert="disabled"
    :to="{ name: 'weather-fish' }"
  >
    <ys-icon class="weather-icon" icon="ysWeather" />
  </router-link>
</template>

<script setup lang="ts">
import '@onxmaps/yellowstone-ui/ys-icon'
import '@onxmaps/yellowstone-ui/icons/ysWeather'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const isWeatherOpen = computed(() =>
  route?.matched.some((r) => r.name === 'weather-fish')
)

interface Props {
  disabled?: boolean
}

const { disabled = false } = defineProps<Props>()
</script>

<style lang="scss" scoped>
@use '@/styles/system/_shadow.scss';
@use '@/styles/system/_breakpoints.scss';

.weather-control {
  position: relative;
  overflow: hidden;
  background-color: var(--ys-color-background-primary);
  color: var(--ys-color-text-primary);
  border-radius: 10px;
  padding: var(--ys-spacing-150);
  display: flex;
  height: 45px;
  width: 45px;
  align-items: center;
  justify-content: center;
  box-shadow: shadow.$Low;

  &.disabled {
    color: var(--ys-color-text-disabled);
  }

  @include breakpoints.mobile() {
    display: none;
  }

  @include breakpoints.app-prototyping() {
    display: flex;
    position: fixed;
    top: 75px;
    right: var(--mobile-controls-offset);
    flex-direction: column;
    align-items: center;
    gap: 2px;
    ys-icon {
      line-height: 0;
    }
  }

  .weather-icon {
    height: 100%;
    width: 100%;
  }

  &:hover,
  &:focus-visible {
    background: var(--ys-color-surface-primary);
  }
}
</style>
